
export const TEXT = 'TEXT';
export const RICHTEXT = 'RICHTEXT';



// WEBPACK FOOTER //
// src/constants/customfiled.js